<template>
  <BaseSelect v-bind="baseSelectAttrs"
              v-on="myListeners"
              :byClick="true"
              :options="options"
              :toggle="toggle"
              @click-outside="close"
              @popover-updated="popoverUpdated"
              @select="selectOption">
    <template v-slot:select>
      <slot name="select" />
    </template>
    <template v-slot:options-top>
      <slot name="options-top" />
    </template>
    <template v-slot:options-bottom>
      <slot name="options-bottom" />
    </template>
  </BaseSelect>
</template>

<script>
  import BaseSelect from '@base/base-select'
  import { FontStyle, Layout } from '@js/styles'
  import { mapGetters } from 'vuex'

  export default {
    name: 'SelectPopoverPrimary',
    inheritAttrs: false,
    components: {
      BaseSelect,
    },
    props: {
      options: { type: Array, required: true },
    },
    data: function () {
      return {
        baseSelectAttrs: {},
        optionContainerStyle: {
          borderRadius: '8px',
          boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)',
          marginTop: '8px',
          padding: `${Layout.space.sm} 0`,
          width: '160px',
        },
        optionStyle: {
          cursor: { '': 'pointer', disabled: 'default' },
          fontFamily: FontStyle.family.primary,
          fontSize: FontStyle.size.md,
          fontWeight: {
            '': FontStyle.weight.md,
            selected: FontStyle.weight.xl,
          },
          height: '32px',
          lineHeight: '32px',
          padding: `0 ${Layout.space.md}`,
        },
        selectStyle: {},
        show: false,
        toggle: false,
      };
    },
    created: function () {
      this.optionContainerStyle = {
        ...this.optionContainerStyle,
        backgroundColor: this.color.light1(),
        border: `solid ${this.color.dark4()}`,
        borderWidth: '1px',
        ...this.$attrs.optionContainerStyle,
      };

      this.optionStyle = {
        ...this.optionStyle,
        backgroundColor: {
          '': this.color.light1(),
          hover: this.color.dark6(),
          active: this.color.dark6(),
          disabled: this.color.light1(),
        },
        color: {
          '': this.color.dark2(),
          disabled: this.color.dark4(),
        },
        ...this.$attrs.optionStyle,
      };

      this.baseSelectAttrs = {
        ...this.baseSelectAttrs,
        ...this.$attrs,
        optionContainerStyle: this.optionContainerStyle,
        optionStyle: this.optionStyle,
      };

      this.selectStyle = {
        ...this.selectStyle,
        ...this.$attrs,
      };
    },
    computed: {
      ...mapGetters('colorTheme', ['color']),
      myListeners: function () {
        const { select, ...listeners } = this.$listeners;
        return listeners;
      },
    },
    methods: {
      close: function () {
        if (this.show) {
          this.toggle = !this.toggle;
        }
      },
      popoverUpdated: function (show) {
        this.show = show;
      },
      selectOption: async function (index) {
        await this.close();
        this.$emit('select', index);
      },
    },
  };
</script>
